import React from 'react';
import { ButtonProps } from '@/types/components';

export const Button: React.FC<ButtonProps> = ({
  children,
  onClick,
  type = 'button',
  variant = 'primary',
  size = 'medium',
  disabled = false,
  className = '',
}) => {
  const baseClasses =
    'inline-flex items-center justify-center font-medium rounded-md focus:outline-none focus:ring-2 focus:ring-offset-2 transition-colors';

  const variantClasses = {
    primary: 'bg-primary text-white hover:bg-primary-700 focus:ring-primary',
    secondary:
      'bg-[#784DEF1A] text-[#5E2AAC] hover:bg-white focus:ring-[#5E2AAC]',
    danger: 'bg-red-600 text-white hover:bg-red-700 focus:ring-red-500',
    neutral: 'bg-gray-200 text-gray-900 hover:bg-gray-300 focus:ring-gray-500',
    white:
      'bg-white border border-gray-300 hover:bg-gray-50 focus:ring-gray-500',
  };

  const sizeClasses = {
    small: 'px-3 py-1.5 text-sm',
    medium: 'px-4 py-2 text-sm',
    large: 'px-6 py-3 text-base',
  };

  const disabledClasses = disabled
    ? 'disabled:bg-[#F7F7F7] disabled:text-[#D1D1D1] disabled:bg-none disabled:cursor-not-allowed disabled:hover:bg-[#F7F7F7]'
    : '';

  // Only apply variant classes if variant is provided and not null
  const variantClass =
    !disabled && variant && variantClasses[variant]
      ? variantClasses[variant]
      : '';

  const classes =
    `${baseClasses} ${variantClass} ${sizeClasses[size]} ${disabledClasses} ${className}`.trim();

  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled}
      className={classes}
    >
      {children}
    </button>
  );
};

export default Button;
